import Cookies from "js-cookie";
export function getToken() {
  return Cookies.get("access_token");
}

export function setToken(token) {
  return Cookies.set("access_token", token);
}

export function removeToken() {
  return Cookies.remove("access_token");
}
